import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Users = [
    {
      id: '01',
      image: '/santa-claus2021/ads/Challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Challenger School ad',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/santa-claus2021/ads/altabank.jpg',
      link: 'https://www.altabank.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Altabank ad',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/santa-claus2021/ads/Hamilton.jpg',
      link: 'https://www.hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Hamilton Park Interiors ad',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/santa-claus2021/ads/cultural-enterprise.jpg',
      link: 'https://www.williamcall.net/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'William Call ad',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/santa-claus2021/ads/LHMiller-Lexus.jpg',
      link: 'https://www.lhmlexus.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Larry H. Miller Lexus ad',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/santa-claus2021/ads/RCWilley.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'RC Willey ad',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/santa-claus2021/ads/Rubys_Inn_fall.jpg',
      link: 'https://rubysinn.com/fallstagearts',
      alt: 'Rubys Inn ad',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/santa-claus2021/ads/UniversityCU.jpg',
      link: 'https://www.ucreditu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'University of Utah Credit Union ad',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/santa-claus2021/ads/certapro.jpg',
      link: 'https://www.certapro.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=utahsymphony',
      alt: 'Certa Pro Painters',
      class: 'webFormat',
    },
  ];

  return (
    <div>
      {Users.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
